import React, { useState } from "react"
import "../../scss/vendorMasterCreation.scss";
import AdvanceSearch from "../../utilsComponent/advanceSearch";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import NoDataFound from "../../utilsComponent/noDataFound";
import ListsPagination from "../../utilsComponent/ListsPagination";
import TextTruncate from "../../utilsComponent/textTruncate";
import { PAGE_NAME_KEYS } from "../../consts";

const SurveyorMaster = (props) => {
  const {productNames} = props
  const [loading, setLoading]=useState(false)
  const [surveyorList, setSurveyorList] = useState([])
  const [searchResultMode, setSearchResultMode] = useState(false)
  const defaultSearch = {
      surveyorId :"",
      firstName: "",
      lastName: "",
      mobileNumber: "",
      email: "",
      state: "",
      district: "" ,
      status: "" 
  }
  const [surveyorSearch, setSurveyorSearch] = useState(defaultSearch)
  const [resetPagination, setResetPagination] = useState(false)
  const [currentItems, setCurrentItems] = useState([])
  const [sortedSurveyorId, setSortedSurveyorId] = useState(true)
  const [sortedFirstName, setSortedFirstName] = useState(true)
  const [sortedLastName, setSortedLastName] = useState(true);
  const [sortedVendorName, setSortedVendorName] = useState(true)
  const [sortedMobile, setSortedMobile] = useState(true)
  const [sortedEmail, setSortedEmail] = useState(true)
  const [sortedStatus, setSortedStatus] = useState(true)
  const [sortedState, setSortedState] = useState(true);
  const [sortedDist, setSortedDist] = useState(true)
  const navigate = useNavigate();


 const navigateToMasterCreation = (SurveyorId) => {
    localStorage.setItem("SurveyorId", SurveyorId)
    navigate(`/dashboard/${PAGE_NAME_KEYS.SURVEYOR_MASTER}/${PAGE_NAME_KEYS.SURVEYOR_MASTER_CREATION}`)
 }
 const sortingData = (data) => {
    switch (data) {
     case "sortedSurveyorId":
         if (!sortedSurveyorId) {
             const lists = [...surveyorList]
             lists.sort((a, b) => a.surveyorId - b.surveyorId)
             setSurveyorList([...lists])
             setSortedSurveyorId(true)
         } else {
             const lists = [...surveyorList]
             lists.sort((a, b) => b.surveyorId - a.surveyorId)
             setSurveyorList([...lists])
             setSortedSurveyorId(false)
         }
         break;
     case "sortedFirstName":
         if (!sortedFirstName) {
             const lists = [...surveyorList]
             lists.sort((a, b) => a.firstName?.toLowerCase().localeCompare(b.firstName?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedFirstName(true)
         } else {
             const lists = [...surveyorList]
             lists.sort((a, b) => b.firstName?.toLowerCase().localeCompare(a.firstName?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedFirstName(false)
         }
         break;
         case "sortedLastName":
             if (!sortedLastName) {
               const lists = [...surveyorList]
               lists.sort((a, b) => a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase()))
               setSurveyorList([...lists])
               setSortedLastName(true)
             } else {
               const lists = [...surveyorList]
               lists.sort((a, b) => b.lastName?.toLowerCase().localeCompare(a.lastName?.toLowerCase()))
               setSurveyorList([...lists])
               setSortedLastName(false)
             }
             break;
             case "sortedVendorName":
                if (!sortedVendorName) {
                  const lists = [...surveyorList]
                  lists.sort((a, b) => a.vendorName?.toLowerCase().localeCompare(b.vendorName?.toLowerCase()))
                  setSurveyorList([...lists])
                  setSortedVendorName(true)
                } else {
                  const lists = [...surveyorList]
                  lists.sort((a, b) => b.vendorName?.toLowerCase().localeCompare(a.vendorName?.toLowerCase()))
                  setSurveyorList([...lists])
                  setSortedVendorName(false)
                }
                break;
            case "sortedMobile":
                if (!sortedMobile) {
                  const lists = [...surveyorList]
                  lists.sort((a, b) => a.mobileNumber?.toLowerCase().localeCompare(b.mobileNumber?.toLowerCase()))
                  setSurveyorList([...lists])
                  setSortedMobile(true)
                } else {
                  const lists = [...surveyorList]
                  lists.sort((a, b) => b.mobileNumber?.toLowerCase().localeCompare(a.mobileNumber?.toLowerCase()))
                  setSurveyorList([...lists])
                  setSortedMobile(false)
                }
                break;
         case "sortedEmail":
             if (!sortedEmail) {
             const lists = [...surveyorList]
             lists.sort((a, b) => a.email?.toLowerCase().localeCompare(b.email?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedEmail(true)
             } else {
             const lists = [...surveyorList]
             lists.sort((a, b) => b.email?.toLowerCase().localeCompare(a.email?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedEmail(false)
             }
             break;
         case "sortedStatus":
             if (!sortedStatus) {
             const lists = [...surveyorList]
             lists.sort((a, b) => a.status?.toLowerCase().localeCompare(b.status?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedStatus(true)
             } else {
             const lists = [...surveyorList]
             lists.sort((a, b) => b.status?.toLowerCase().localeCompare(a.status?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedStatus(false)
             }
             break;
         case "sortedDist":
             if (!sortedDist) {
             const lists = [...surveyorList]
             lists.sort((a, b) => a.district?.toLowerCase().localeCompare(b.district?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedDist(true)
             } else {
             const lists = [...surveyorList]
             lists.sort((a, b) => b.district?.toLowerCase().localeCompare(a.district?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedDist(false)
             }
             break;
         case "sortedState":
             if (!sortedState) {
             const lists = [...surveyorList]
             lists.sort((a, b) => a.state?.toLowerCase().localeCompare(b.state?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedState(true)
             } else {
             const lists = [...surveyorList]
             lists.sort((a, b) => b.state?.toLowerCase().localeCompare(a.state?.toLowerCase()))
             setSurveyorList([...lists])
             setSortedState(false)
             }
             break;
   default:
 }

}


  return (
    <>
            <section className="p-4">
                <h1 className="headerclaim">Surveyor Search</h1>
                <hr className="upper_hr" />
                <div className="outer-boxIndividual">
                    <h2 className="heading_h2Masters">Surveyor Search</h2>
                    <div className="inner-boxMasters" style={{backgroundColor:"white"}}>
                    <div className = "container-fluid selectButtonsMasters">
                    <AdvanceSearch
                        loading={loading}
                        setLoading={setLoading}
                        showAdvanceSearch={false}
                        setList={setSurveyorList}
                        list={surveyorList}
                        searchFields={surveyorSearch}
                        setsearchFields={setSurveyorSearch}
                        setSearchResultMode={setSearchResultMode}
                        module="surveyor_master"
                        defaultSearch={defaultSearch}
                        resetFields={defaultSearch}
                        navigateToMasterCreation={navigateToMasterCreation}
                        setResetPagination={setResetPagination}
                        resetPagination={resetPagination}
                        productNames={productNames}
                        />
                        {
                            loading ? (
                                <LoadingPage/>
                            ) : (
                                surveyorList && surveyorList.length > 0 ? (
                                  <>
                                    <table className="table table-strip mt-3 text-left">
                                        <thead>
                                            <tr>
                                                <th scope="col">Surveyor ID<a className="pointer text-body ms-1" onClick={() => sortingData("sortedSurveyorId")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>First Name<a className="pointer text-body ms-1" onClick={() => sortingData("sortedFirstNameId")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>Last Name<a className="pointer text-body ms-1" onClick={() => sortingData("sortedLastNameId")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>Vendor Name<a className="pointer text-body ms-1" onClick={() => sortingData("sortedVendorName")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>Mobile Number<a className="pointer text-body ms-1" onClick={() => sortingData("sortedMobile")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>Email<a className="pointer text-body ms-1" onClick={() => sortingData("sortedEmail")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>Status<a className="pointer text-body ms-1" onClick={() => sortingData("sortedStatus")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>State<a className="pointer text-body ms-1" onClick={() => sortingData("sortedState")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                <th>District<a className="pointer text-body ms-1" onClick={() => sortingData("sortedDist")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentItems.map(list => (
                                                    <tr>
                                                        <td style={{color: "lightblue"}} className="pointer" onClick={() => navigateToMasterCreation(list.surveyorId)}>{list.surveyorId}</td>
                                                        <td className="view-more-less-text">{list.firstName}</td>
                                                        <td className="view-more-less-text">{list.lastName}</td>
                                                        <td className="view-more-less-text">{list.vendorName}</td>
                                                        <td>{list.mobileNumber}</td>
                                                        <td>{<TextTruncate text={list.email} length={10} />}</td>
                                                        <td style={{color: "green"}}>{list.status}</td>
                                                        <td>{list.state}</td>
                                                        <td>{list.district}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <ListsPagination setCurrentItems={setCurrentItems} lists={surveyorList}/>                                                
                                  </>
                                ) : <NoDataFound text="No Data Found"/>
                            )
                        }
                </div>
                    </div>
                </div>
            </section>
        </>
  )
};

export default SurveyorMaster;